module.exports = __webpack_public_path__ + "/build/web/images/post-convention-discount-left-1-2@2x.f167a1c8bf3a793c530075595729cd65.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/post-convention-discount-left-1-2@2x.jpg
// module id = 180
// module chunks = 13